<template>
  <BlogPostLayout>
    <template #image>
      <BlogHeader
        :title="postData.title"
        :excerpt="postData.excerpt"
        :image="postData.image"
        :author="postData.author"
        :date="postData.date"
        :updatedAt="postData.updatedAt"
        :categories="postData.categories"
        :readTime="postData.readTime"
      />
    </template>
    <template #content>
      <article class="blog-content" lang="es">
        <section class="intro">
          <p>
            La mayoría de las malas fotos 360° no se deben a un mal hardware o a
            una mala aplicación: son causadas por un pequeño conjunto de errores
            de técnica completamente evitables una vez que los conoces. Tras
            analizar miles de tours virtuales creados en la plataforma Travvir,
            aquí están los 10 errores de fotografía 360° más comunes y cómo
            corregirlos.
          </p>
        </section>

        <section>
          <h2>Errores de estabilidad y movimiento</h2>

          <h3>Error 1: Girar demasiado rápido</h3>
          <p>
            <strong>Qué causa:</strong> imágenes borrosas, errores de costura y
            huecos en la cobertura que aparecen como zonas negras en la imagen
            final.
          </p>
          <p>
            <strong>La corrección:</strong> Gira a razón de una imagen cada 2–3
            segundos, moviéndote unos 15° por paso. Espera que el indicador de
            la app se ponga en verde antes de pasar a la siguiente zona.
          </p>

          <h3>Error 2: Capturar a pulso sin soporte</h3>
          <p>
            <strong>Qué causa:</strong> vibraciones, altura inconsistente entre
            imágenes y errores de paralaje.
          </p>
          <p>
            <strong>La corrección:</strong> Usa siempre un trípode. Uno básico
            de 20 € con soporte para smartphone es suficiente para la mayoría de
            interiores.
          </p>
        </section>

        <section>
          <h2>Errores de iluminación</h2>

          <h3>Error 3: Exposición inconsistente entre imágenes</h3>
          <p>
            <strong>Qué causa:</strong> "bandas" visibles en la imagen
            ensamblada donde una zona es más clara que otra.
          </p>
          <p>
            <strong>La corrección:</strong> Bloquea la exposición antes de
            empezar. En iPhone: mantén pulsado para bloquear AE/AF. En Android:
            modo Pro con ISO y obturación fijos.
          </p>

          <h3>Error 4: Iluminación insuficiente</h3>
          <p>
            <strong>Qué causa:</strong> imágenes oscuras, ruido digital elevado,
            pérdida de detalle en sombras.
          </p>
          <p>
            <strong>La corrección:</strong> Abre todas las persianas, enciende
            todas las luces y añade iluminación suplementaria en zonas
            especialmente oscuras si es necesario.
          </p>
        </section>

        <section>
          <h2>Errores de preparación del espacio</h2>

          <h3>Error 5: Espacio desordenado</h3>
          <p>
            <strong>Qué causa:</strong> impresión negativa en los visitantes. Un
            tour de un espacio desordenado disuade a los clientes potenciales.
          </p>
          <p>
            <strong>La corrección:</strong> Prepara el espacio como para una
            visita física importante. Recoge los objetos personales y destaca
            los elementos positivos.
          </p>

          <h3>Error 6: El fotógrafo aparece en la imagen</h3>
          <p>
            <strong>Qué causa:</strong> tu reflejo en espejos o tu sombra
            visible rompen la inmersión.
          </p>
          <p>
            <strong>La corrección:</strong> Posiciona el trípode evitando los
            espejos en el campo visual directo. Usa disparador remoto o el
            temporizador de la app y aléjate del campo de visión.
          </p>
        </section>

        <section>
          <h2>Errores de navegación y publicación</h2>

          <h3>Error 7: Hotspots mal posicionados</h3>
          <p>
            Los hotspots demasiado pequeños, mal ubicados o poco visibles no
            recibirán clics. Colócalos a la altura de los ojos en la imagen
            360°, con tamaño suficiente para ser fácilmente detectados en móvil.
          </p>

          <h3>Error 8: Habitaciones que faltan en el tour</h3>
          <p>
            Los visitantes notan inmediatamente las habitaciones que faltan y lo
            interpretan como señal negativa. Incluye todos los espacios, incluso
            los pequeños o los que están en peor estado.
          </p>

          <h3>Error 9: Sin optimización SEO</h3>
          <p>
            Un tour sin título, descripción ni datos estructurados no será
            indexado por Google. Completa todos los campos de metadatos en
            Travvir e integra el tour en tu ficha de Google Business Profile.
          </p>

          <h3>Error 10: Tour no optimizado para móvil</h3>
          <p>
            Más del 70 % de las visualizaciones se hacen en móvil. Prueba
            sistemáticamente tu tour en smartphone antes de publicarlo.
            Comprueba la navegación giroscópica, la velocidad de carga y la
            visualización de los hotspots.
          </p>
        </section>

        <section>
          <h2>Preguntas frecuentes</h2>

          <h3>¿Se pueden corregir los errores después de publicar?</h3>
          <p>
            Sí, la mayoría de los errores de navegación, hotspots y metadatos se
            pueden corregir directamente en el panel de Travvir sin necesidad de
            volver a capturar. Solo los errores de calidad de imagen requieren
            una nueva sesión de captura.
          </p>
        </section>
        <section class="continue-reading">
          <h2>Seguir Leyendo</h2>
          <ul>
          <li><a href="/blog/es/corregir-fotos-360-borrosas">Fotos 360° Borrosas: 6 Causas y Soluciones Concretas 2026</a></li>
          <li><a href="/blog/es/tamano-imagen-tour-virtual">Tamaño y Resolución de Imágenes para Tours Virtuales 360° 2026</a></li>
          <li><a href="/blog/es/fotos-360-con-celular">Cómo Tomar Fotos 360° con tu Celular (Sin Cámara Especial) 2026</a></li>
          <li><a href="/blog/es/tomar-fotos-360-movil">Cómo Tomar Fotos 360° con el Móvil: Técnica Completa 2026</a></li>
          <li><a href="/blog/es/tour-virtual-360-principiantes">Tour Virtual 360° para Principiantes: Crea tu 1er Tour desde el Móvil</a></li>
          <li><a href="/blog/es/tour-virtual-360-guia-completa">Tour Virtual 360°: Guía Completa para Principiantes (2026)</a></li>
          </ul>
        </section>



        <RelatedPosts
          :currentSlug="postData.slug"
          :currentCategories="postData.categories"
        />
      </article>
    </template>
  </BlogPostLayout>
</template>

<script setup>
import blogPostsData from "~/data/blogPosts.json";

const postData = blogPostsData.find((p) => p.slug === "errores-fotografia-360");

useBlogSeo({
  title: "10 Errores de Fotografía 360° que Debes Evitar en 2026 | Travvir",
  description:
    "Evita los 10 errores más comunes en fotografía 360°: giro rápido, iluminación, espacio desordenado, hotspots, SEO, optimización móvil. Soluciones concretas.",
  keywords:
    "errores fotografía 360, errores foto 360, mala calidad foto 360, mejorar foto 360, fotografía 360 consejos",
  slug: "errores-fotografia-360",
  image: postData?.image,
  postData,
  lang: "es",
  faqItems: [
    {
      question: "¿Se pueden corregir los errores después de publicar?",
      answer:
        "Sí, la mayoría de errores de navegación y metadatos se pueden corregir en Travvir. Solo los errores de imagen requieren nueva captura.",
    },
  ],
});

</script>
